module.exports = __webpack_public_path__ + "static/neon-small-f8513f18b1fd250fe03da71c97e8a6cf.png";